<template>
    <div :class="shown ? 'trash-item trash-1 show' : 'trash-item trash-1'">
        <div class="img-ct">
            <img src="@/assets/img/icons/glass-bottle.svg" alt="">
        </div>
        <div class="trash-specs">
            <div class="name">{{$t('item_glassbottle')}}</div>
            <div class="trash-value">+ {{value}} <small>{{$t('item_points')}}</small></div>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        "shown", "value"
    ]
}
</script>